import * as React from "react";
import { Box } from "@mui/material";
import Loading from "../../../../auxiliares/loading";
import UserTable from "./userTable";
import { options } from "@config";

const ItemTableContainer = () => {
  const [items, setItems] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);

  const refresh = React.useCallback(async () => {
    setLoading(true);
    const response = await fetch(options.api.url + "user", {
      method: "GET",
      mode: "cors",
      headers: { "Content-Type": "application/json" },
    });
    const data = await response.json();
    setItems(data.usersSearched || []);
    setLoading(false);
  }, []);

  React.useEffect(() => {
    refresh();
  }, [refresh]);

  const putUser = async (userId: string, payload: any) => {
    const res = await fetch(`${options.api.url}userid?uid=${encodeURIComponent(userId)}`, {
      method: "PUT",
      mode: "cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      let msg = "Error actualizando usuario";
      try {
        const j = await res.json();
        msg = j?.error || msg;
      } catch {}
      throw new Error(`${msg} (${userId})`);
    }
  };

  const bulkSetStatus = async (ids: string[], status: "active" | "inactive") => {
    if (!ids.length) return;

    setSaving(true);
    try {
      const byId = new Map(items.map((it) => [it.user, it]));

      const CONCURRENCY = 5;
      const queue = [...ids];

      const workers = new Array(CONCURRENCY).fill(0).map(async () => {
        while (queue.length) {
          const id = queue.shift()!;
          const current = byId.get(id);
          if (!current) continue;

          await putUser(id, { ...current, status });
        }
      });

      await Promise.all(workers);

      await refresh();
    } finally {
      setSaving(false);
    }
  };

  const onActivate = (ids: string[]) => bulkSetStatus(ids, "active");
  const onInactivate = (ids: string[]) => bulkSetStatus(ids, "inactive");

  return (
    <Box sx={{ minWidth: 0, width: "100%" }}>
      {loading ? (
        <Loading />
      ) : (
        <UserTable
          items={items}
          onActivate={onActivate}
          onInactivate={onInactivate}
        />
      )}

      {saving && <Loading />}
    </Box>
  );
};

export default ItemTableContainer;
